import { render, staticRenderFns } from "./Attribute.vue?vue&type=template&id=2f5d06a6&scoped=true&"
import script from "./Attribute.vue?vue&type=script&lang=ts&"
export * from "./Attribute.vue?vue&type=script&lang=ts&"
import style0 from "./Attribute.vue?vue&type=style&index=0&id=2f5d06a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5d06a6",
  null
  
)

export default component.exports